import { useGlobalContext } from 'Context';
import React from 'react';
import NewReferralButton from 'v3/Components/Shared/NewReferralButton';
import HalfLogo from '../../Assets/half-logo.svg';
import { ENDPOINTS } from 'Models/Templates/Routes/Routes';
import { useDataFetcher } from 'Utilities';
import { AsyncStatus } from 'Models';
import ClientSelector from 'v3/Components/Shared/ClientSelector';
import Dropdown, {
  DropdownDbOption,
  DropdownOption,
} from 'v3/Components/Form/Dropdown';

interface ClientHeaderProps {
  client: DropdownOption | undefined;
  setClient: (client: DropdownOption | undefined) => void;
}

const NewReferralCta = React.memo(function NewReferralCta() {
  return (
    <>
      <div className="dashboard-header-cta-text">
        Ready to submit a new case for review?
      </div>
      <div className="dashboard-header-cta-button">
        <NewReferralButton text="Start a New Referral" variant="white" />
      </div>
      <img
        className="dashboard-header-cta-image"
        src={HalfLogo}
        alt="Stradix Logo"
      />
    </>
  );
});

function ClientHeader({ client, setClient }: ClientHeaderProps) {
  const globalcontext = useGlobalContext();
  const currentUser = globalcontext[0]?.currentUser;

  return (
    <div className="dashboard-header">
      <div className="jumbo">
        <div className="jumbo-title">
          <div className="dashboard-header-title">
            Welcome, <span className="user-name">{currentUser?.firstName}</span>
          </div>
          <div className="dashboard-header-client-selector">
            <ClientSelector
              value={client}
              onClientChange={setClient}
              disableUrlSync={true}
            />
          </div>
        </div>
        <div className="dashboard-header-subtitle">
          Effortlessly initiate and manage your referrals until they are ready
          for retrieval
        </div>
      </div>
      <div className="dashboard-header-cta">
        <NewReferralCta />
      </div>
    </div>
  );
}

const MemoizedClientHeader = React.memo(
  ClientHeader,
  (prevProps, nextProps) =>
    prevProps.setClient === nextProps.setClient &&
    prevProps.client?.id === nextProps.client?.id &&
    prevProps.client?.name === nextProps.client?.name
);

export default MemoizedClientHeader;
